import { useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import DateTimePicker, { DateType, useDefaultStyles } from 'react-native-ui-datepicker';
import Modal from 'theme/Modal';
import Text from 'theme/Text';
import dayjs from 'dayjs'
import { colorList } from 'utils/colors';
import HelperLocale from 'utils/helper-locale';
import { ThemedValues } from 'styles/themed';
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import Icon from 'components/atoms/Icon'
import DatepickerStyles, { DatepickerContainerStyles } from 'theme/Datepicker/DatepickerStyles';
import HelperDate from 'utils/helper-date';

const Datepicker = ({ mode = 'date', value, onSelect = undefined, min, max }) => {

    const [date, setDate] = useState(value ? HelperDate.date(value) : HelperDate.date());
    const [show, setShow] = useState(false);

    const defaultStyles = useDefaultStyles();

    const onChange = ({ date }) => {

        date = HelperDate.date( date )

        setDate( date );
        setShow( false );

        if( onSelect ) {
            onSelect( date );
        }
    };

    return (
        <Pressable onPress={ setShow.bind( this, true ) }>
            <View
                style={styles.container}>

                <Text 
                    style={styles.inputText}>
                    
                    { date.format('YYYY-MM-DD') }
                </Text>

                <Icon 
                    icon={ IconSystemConstants.CALENDAR } 
                    color={ colorList.TEXT.primary }
                />
            </View>
                
            <Modal
                visible={ show }
                onClose={ setShow.bind( this, false ) }
                headerStyle={ DatepickerContainerStyles.headerStyle }
                modalStyle={ DatepickerContainerStyles.modalStyle }
                closeStyle={ DatepickerContainerStyles.closeStyle }>
                
                <DateTimePicker
                    mode="single"
                    initialView="day"
                    date={ date }
                    locale={ HelperLocale.localeSubstr( HelperLocale.getDeviceLocale() ) }
                    firstDayOfWeek={1}
                    onChange={ onChange}
                    containerStyle={ DatepickerContainerStyles.picker }
                    style={ DatepickerContainerStyles.picker }
                    styles={{
                        ...defaultStyles,
                        ...DatepickerStyles,
                    }}
                />
            </Modal>
        </Pressable>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 10,
        borderColor: colorList.GREY.primary,
        borderWidth: 1,
        borderRadius: ThemedValues.borderRadius,
        backgroundColor: colorList.WHITE.primary,
    },

    inputText: {
        fontSize: ThemedValues.fontSize,
        color: colorList.TEXT.primary,
    },

    picker: {
        width: '100%',
    }
})

export default Datepicker;